import pathfinder from '@fiverr-private/pathfinder';

export const LEARN_MORE_LINK = pathfinder(
    'help_center_article',
    { article_id: '5244809819153-Seller-Coupons-for-buyers' },
    { query: { segment: 'buyer' } }
);
